import React, { useState, useEffect } from 'react';
import APModal from 'components/Modal/APModal';
import InputField from 'components/FormFields/InputField';
import clsx from 'clsx';
import PropTypes from 'prop-types';

import './styles.scss';

const DeleteConfirmation = ({
  show = false,
  className,
  header = true,
  title,
  cancelText = 'cancel',
  deleteText = 'delete',
  confirmText = 'CONFIRM',
  requireConfirmation = false,
  handleConfirm,
  handleClose,
  name = 'delete-confirmation',
  size,
  children,
}) => {
  const [confirmInputText, setConfirmInputText] = useState('');
  const [hasError, setHasError] = useState(false);

  const onChange = (event) => {
    setConfirmInputText(event.target.value);
    if (hasError) {
      setHasError(false);
    }
  };

  const onConfirm = (e) => {
    if (!requireConfirmation) {
      handleConfirm(e);
      return;
    }

    if (confirmInputText === confirmText) {
      handleConfirm();
    } else {
      setHasError(true);
    }
  };

  useEffect(() => {
    if (!show) {
      setConfirmInputText('');
      setHasError(false);
    }
  }, [show]);

  return (
    <APModal
      className={clsx(className)}
      open={show}
      name={name}
      hasHeader={header}
      size={size}
      title={title}
      onClose={handleClose}
      actions={(
        <>
          {requireConfirmation &&(
            <div className="delete-confirmation-modal__confirm">
              <InputField
                name={`${name}-confirm`}
                className="delete-confirmation-modal__confirm-field"
                value={confirmInputText}
                onChange={onChange}
                visuallyHidden
                showError={hasError}
              />
              {hasError && (
                <div className='delete-confirmation-modal__confirm-error'>
                  Please enter text as displayed to confirm.
                </div>
              )}
            </div>
          )}
          <button
            type="button"
            className="button button-cancel"
            onClick={handleClose}
          >
            {cancelText}
          </button>
          <button
            type="button"
            className="button button-delete"
            onClick={onConfirm}
          >
            {deleteText}
          </button>
        </>
      )}
    >
      {children}
    </APModal>
  );
};

DeleteConfirmation.propTypes = {
  show: PropTypes.bool,
  title: PropTypes.string,
  cancelText: PropTypes.string,
  deleteText: PropTypes.string,
  confirmText: PropTypes.string,
  requireConfirmation: PropTypes.bool,
  handleClose: PropTypes.func,
  handleConfirm: PropTypes.func,
};

DeleteConfirmation.defaultTypes = {
  show: false,
};

export default DeleteConfirmation;
